import { LogoIcon } from './LogoIcon';

export const AnimatedLogoIcon = ({ size = 38 }) => (
    <>
        <style>{`
            @keyframes ani-ring-spin  { from { transform: rotate(0deg);  } to { transform: rotate(360deg);  } }
            @keyframes ani-ring2-spin { from { transform: rotate(0deg);  } to { transform: rotate(-360deg); } }
            @keyframes ani-pulse-glow {
                0%, 100% { box-shadow: 0 0 0 0 rgba(11,49,99,0.35), 0 2px 10px rgba(11,49,99,0.25); }
                50%       { box-shadow: 0 0 0 6px rgba(11,49,99,0),  0 4px 18px rgba(11,49,99,0.4);  }
            }
        `}</style>
        <div style={{
            position: 'relative', width: size, height: size,
            display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
        }}>
            {/* outer spinning ring */}
            <span style={{ position: 'absolute', inset: -3, borderRadius: '50%', border: '2px solid transparent', borderTopColor: 'var(--primary-color)', borderRightColor: '#1FABB3', animation: 'ani-ring-spin 1.6s linear infinite', pointerEvents: 'none' }} />
            {/* inner counter-spinning ring */}
            <span style={{ position: 'absolute', inset: 2, borderRadius: '50%', border: '1.5px solid transparent', borderBottomColor: 'var(--primary-color)', borderLeftColor: 'rgba(11,49,99,0.35)', animation: 'ani-ring2-spin 2.2s linear infinite', pointerEvents: 'none' }} />
            {/* logo circle — smaller than container so both rings are visible */}
            <span style={{ position: 'relative', width: size - 8, height: size - 8, borderRadius: '50%', background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', animation: 'ani-pulse-glow 2.4s ease-in-out infinite', boxShadow: '0 2px 8px rgba(11,49,99,0.15)', overflow: 'hidden', flexShrink: 0 }}>
                <LogoIcon size={Math.round((size - 8) * 0.72)} />
            </span>
        </div>
    </>
);
